import { useEffect } from 'react';

import { scrollTop } from '@share/utils';

import { Blogs } from '../../components/blogs/component';

import './style.scss';

export function BlogsPage() {
  useEffect(() => {
    setTimeout(() => {
      scrollTop();
    }, 300);
  }, []);

  return (
    <div className="blogs-page">
      <Blogs />
    </div>
  );
}
